import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { SocialFeed } from "@/components/SocialFeed";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let frame;
        const loop = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(loop);
        };
        frame = requestAnimationFrame(loop);

        const onClick = (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            const hash = anchor.getAttribute("href");
            if (hash.length > 1 && document.querySelector(hash)) {
                e.preventDefault();
                lenis.scrollTo(hash, { offset: -84, duration: 1.2 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            document.removeEventListener("click", onClick);
        };
    }, []);

    return (
        <div className="App">
            <div className="grain-overlay" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Services />
                <Portfolio />
                <SocialFeed />
                <Contact />
            </main>
            <Footer />
            <WhatsAppButton />
            <Toaster position="bottom-left" richColors />
        </div>
    );
}

export default App;
